<template>
  <div class="toast" @keyup.enter="loginFn">
    <el-dialog :visible="isshow" :modal-append-to-body="false" @close="changeStatus">
      <div slot="title" class="jumFpeedback_head">
        <img src="/img/logo.e85e07f3.png" alt="" />
        <b></b>
        <span>登录</span>
      </div>
      <div class="jumpFeedback_body">
        <div :class="userFocusStatus.styleStatus ? 'inputSty active' : 'inputSty'">
          <img src="/img/phone.d17175b6.png" alt="" />
          <input
            type="text"
            v-model="login.phone"
            placeholder="在此输入手机号/邮箱"
            @focus="focusFn(true)"
            @input="changeFn(true)"
            @blur="blurFn(true)"
          />
          <img
            v-show="userFocusStatus.delIsShow"
            src="/img/del.3e24f5a3.png"
            alt=""
            @click="delBtn(true)"
          />
        </div>
        <div :class="pwdFocusStatus.styleStatus ? 'inputSty active' : 'inputSty'">
          <img src="/img/pwd.0c0f0a80.png" alt="" />
          <input
            type="password"
            v-model="login.pwd"
            placeholder="在此输入密码"
            @focus="focusFn(false)"
            @input="changeFn(false)"
            @blur="blurFn(false)"
          />
          <img
            v-show="pwdFocusStatus.delIsShow"
            src="/img/del.3e24f5a3.png"
            alt=""
            @click="delBtn(false)"
          />
        </div>
        <div class="loginBtn" @click="loginFn">
          <span>登录</span>
        </div>
        <div class="quickTips">
          <span @click="registFn">快速注册</span>
          <span @click="forgetFn">忘记密码</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <span>其他登录方式：</span>
        <div class="elseLogin">
          <span @click="wxlogin"><img src="/img/wx-login.png" alt="" /></span>
          <span @click="weiboLogin"><img src="/img/weibo-login.png" alt="" width="36px" /></span>
          <span @click="aliLogin"><img src="/img/alipay.76bfaa32.png" alt="" width="36px" /></span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { setToken, setUser } from '@/utils/auth'
import { EventBus } from '@/utils/event-bus'

export default {
  name: 'LoginToast',
  data() {
    return {
      login: { phone: '', pwd: '' },
      userFocusStatus: { styleStatus: false, delIsShow: false },
      pwdFocusStatus: { styleStatus: false, delIsShow: false },
      isShowRegi: false,
      isForget: false,
      isshow: false
    }
  },
  props: {
    status: { type: Boolean, default: false },
    isClose: { type: Function, default() {} }
  },
  watch: {
    status() {
      this.isshow = this.status
    }
  },
  methods: {
    wxlogin() {
      axios({ url: '/realNet/vxlogin/geturl', method: 'get' }).then(res => {
        if (res.data.code === 200) {
          localStorage.setItem('authtype', 'wxlogin')
          window.location.href = res.data.message
        } else {
          this.$message({ showClose: true, message: res.data.message, type: 'warning', duration: 1000 })
        }
      })
    },
    aliLogin() {
      axios({ url: '/realNet/alilogin/geturl', method: 'get' }).then(res => {
        if (res.data.code === 200) {
          localStorage.setItem('authtype', 'alilogin')
          window.location.href = res.data.message
        } else {
          this.$message({ showClose: true, message: res.data.message, type: 'warning', duration: 1000 })
        }
      })
    },
    weiboLogin() {
      axios({ url: '/realNet/wblogin/geturl', method: 'get' }).then(res => {
        if (res.data.code === 200) {
          localStorage.setItem('authtype', 'weibologin')
          window.location.href = res.data.message
        } else {
          this.$message({ showClose: true, message: res.data.message, type: 'warning', duration: 1000 })
        }
      })
    },
    registFn() {
      this.isshow = false
      this.isShowRegi = true
    },
    forgetFn() {
      this.isshow = false
      this.isForget = true
    },
    changeStatus() {
      if (this.isShowRegi) {
        this.isClose(1)
        this.isShowRegi = false
        return
      }
      if (this.isForget) {
        this.isClose(2)
        this.isForget = false
        return
      }
      this.isClose(0)
    },
    focusFn(isUser) {
      if (isUser) this.userFocusStatus.styleStatus = true
      else this.pwdFocusStatus.styleStatus = true
    },
    blurFn(isUser) {
      if (isUser) {
        this.userFocusStatus.styleStatus = false
        this.userFocusStatus.delIsShow = false
        if (this.login.phone) this.userFocusStatus.delIsShow = true
      } else {
        this.pwdFocusStatus.styleStatus = false
        this.pwdFocusStatus.delIsShow = false
        if (this.login.pwd) this.pwdFocusStatus.delIsShow = true
      }
    },
    changeFn(isUser) {
      if (isUser) {
        this.userFocusStatus.delIsShow = !!this.login.phone
      } else {
        this.pwdFocusStatus.delIsShow = !!this.login.pwd
      }
    },
    delBtn(isUser) {
      if (isUser) {
        this.login.phone = ''
        this.userFocusStatus.delIsShow = false
      } else {
        this.login.pwd = ''
        this.pwdFocusStatus.delIsShow = false
      }
    },
    loginFn() {
      const timestamp = Date.parse(new Date())
      if (this.login.phone && this.login.pwd) {
        const data = { loginName: this.login.phone, password: this.login.pwd }
        axios({
          method: 'post',
          url: '/realNet/customer/login?_=' + timestamp,
          data
        }).then(res => {
          if (res.data.code == 200) {
            const result = res.data.result
            setToken(result.token)
            setUser(JSON.stringify(result.user))
            this.$store.state.name = result.user.name
            this.$store.state.avatar = result.user.avatar
            EventBus.$emit('getUser', result.user)
            this.isClose()
            this.$message({
              showClose: true,
              message: '登录成功',
              type: 'success',
              duration: 1000,
              onClose: () => {
                this.$emit('resign', this.login)
              }
            })
            this.$store.commit('setLoginStatus', true)
          } else {
            this.isClose()
            this.$message({ showClose: true, message: res.data.message, type: 'error', duration: 1000 })
          }
        })
      } else if (!this.login.phone) {
        this.$message({ showClose: true, message: '请先输入手机号或邮箱', type: 'warning', duration: 1000 })
      } else {
        this.$message({ showClose: true, message: '请填写密码', type: 'warning', duration: 1000 })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toast {
  ::v-deep .el-dialog {
    width: 480px;
    border-radius: 8px;
  }

  ::v-deep .el-dialog__header {
    width: 100%;
    box-sizing: border-box;
  }

  ::v-deep .el-dialog__body,
  ::v-deep .el-dialog__footer {
    padding: 0;
  }

  .jumFpeedback_head {
    display: flex;
    align-items: center;

    img { margin-top: 0; }

    b {
      width: 4px;
      height: 4px;
      margin: 0 10px;
      background-color: #3bc0d0;
      border-radius: 50%;
      display: inline-block;
    }

    span {
      font-size: 18px;
      color: #3bc0d0;
    }
  }

  .jumpFeedback_body {
    width: 100%;
    padding: 40px 61px 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: column;

    .inputSty {
      width: 100%;
      height: 55px;
      margin-bottom: 20px;
      border-bottom: 1px solid #e1e9eb;
      display: flex;
      align-items: center;

      &.active {
        border-bottom: 1px solid #3bc0d0 !important;
      }

      img { cursor: pointer; }

      input {
        width: 78%;
        height: 30px;
        border: none;
        margin-left: 25px;
        outline: none;
        font-size: 16px;

        &::placeholder { color: #ccc; }
      }
    }

    .loginBtn {
      width: 360px;
      height: 50px;
      margin-top: 20px;
      background-color: #3bc0d0;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        font-size: 18px;
        color: #fff;
        letter-spacing: 1px;
      }
    }

    .quickTips {
      width: 50%;
      height: 30px;
      margin: 25px 0 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 16px;
        color: #3bc0d0;
        position: relative;
        cursor: pointer;

        &:last-of-type::before {
          content: "";
          width: 1px;
          height: 16px;
          background-color: #ccc;
          position: absolute;
          left: -30px;
          top: 4px;
        }
      }
    }
  }

  .dialog-footer {
    width: 100%;
    height: 60px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    background-color: #f3f7f8;
    border-radius: 0 0 8px 8px;

    > span {
      font-size: 14px;
      color: #666;
    }

    .elseLogin {
      width: 160px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      img { cursor: pointer; }

      span {
        cursor: pointer;
        img { width: 36px; height: 36px; border-radius: 50%; }
      }
    }
  }
}
</style>
